module.exports = __webpack_public_path__ + "img/product5.ca931cea.png";